import { render, staticRenderFns } from "./EmailingTemplateView.vue?vue&type=template&id=0ba43152&scoped=true&"
import script from "./EmailingTemplateView.vue?vue&type=script&lang=js&"
export * from "./EmailingTemplateView.vue?vue&type=script&lang=js&"
import style0 from "./EmailingTemplateView.vue?vue&type=style&index=0&id=0ba43152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba43152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VTextField})
